import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function Parempuyre() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Parempuyre | PVC Alu Bois | Baies Vitrées";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Parempuyre ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Parempuyre, fenêtres PVC Parempuyre, baies vitrées Parempuyre, vitrier Parempuyre');
    }

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '44.9500;-0.6000');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '44.9500;-0.6000';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Parempuyre, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Parempuyre, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Parempuyre" />
      <Hero city="Parempuyre" />
      <Services city="Parempuyre" />
      <BayWindows city="Parempuyre" />
      <WhatsAppDiagnostic city="Parempuyre" />
      <Contact city="Parempuyre" />
      <Footer city="Parempuyre" />
    </div>
  );
}